import script from "./RolesPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./RolesPanel.vue?vue&type=script&setup=true&lang=js"

import "./RolesPanel.vue?vue&type=style&index=0&id=2a91c91e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a91c91e"]])

export default __exports__